// set counties
export const setCities = (state, payload) => { state.cities = payload };
export const setCounties = (state, payload) => { state.counties = payload };
export const setCountries = (state, payload) => { state.countries = payload };
export const setCompanies = (state, payload) => { state.companies = payload };
export const setUsers = (state, payload) => { state.users = payload };
export const setShowUploadDrawer = (state, payload) => { state.showUploadDrawer = payload };
export const setShowUploadDrawer2 = (state, payload) => { state.showUploadDrawer2 = payload };

export const formatPrice = (state, payload)  => {
    let val = (payload/1).toFixed(2).replace('.', ',');
    let x = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    console.log(x);
    return x;
};

export const setValidationErrors = (state, payload) => { state.validationErrors.errors = payload };
export const setValidationErrorsExists = (state, payload) => { state.validationErrorsExists = payload; };
export const setRates = (state, payload) => { state.rates = payload };
export const setDayRate = (state, payload) => { state.dayRate = payload };
